module.exports = __webpack_public_path__ + "static/media/STATELESS.6198754f.svg";